import * as React from "react";
const SvgSparkle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m15.694 7.577-2.296-.658a6.27 6.27 0 0 1-4.337-4.346l-.656-2.3a.439.439 0 0 0-.81 0l-.656 2.3a6.29 6.29 0 0 1-4.337 4.346l-2.296.658a.421.421 0 0 0 0 .812l2.296.657a6.27 6.27 0 0 1 4.337 4.347l.656 2.3a.422.422 0 0 0 .659.222.42.42 0 0 0 .151-.222l.656-2.3a6.273 6.273 0 0 1 4.338-4.347l2.295-.657a.421.421 0 0 0 0-.812"
    />
  </svg>
);
export default SvgSparkle;
